<div class="inline-flex text-sm font-bold uppercase">
  {{ size() | adminShipmentSizeType | async }}
</div>
